<div class="dialog-container" [ngClass]="class">
  <button
    class="info-icon-button"
    type="button"
    aria-label="More information"
    (click)="iconModal.showModal()">
    <zui-icon
      class="info-icon"
      icon="info_outline">
    </zui-icon>
  </button>

  <dialog class="dialog-content-container" #iconModal>
    <ng-content></ng-content>
    <button
      class="close-button"
      mat-flat-button
      color="accent"
      (click)="iconModal.close()">
      {{ translateService.get( translations.uiUtilities.modalCloseButton) | async | translate }}
    </button>
  </dialog>
</div>
